import { GenericHero } from "../HomepageHeroV2/index";
import News from "../../dynamic/News";
import StoryTeller from "../../dynamic/StoryTeller";
import Events from "../../dynamic/Events";
import HomeCTA from "../../dynamic/HomeCTA";
import AdBanner from "../../static/AdBanner";
import WSCBlaze from "../../dynamic/WSCBlaze";

export default {
  latestNewsGridModule: {
    Component: News,
    columnSpan: 1,
    rowSpan: 1
  },
  homeHeroCarouselModule: {
    Component: GenericHero,
    columnSpan: 2,
    rowSpan: 1
  },
  genericCtaModule: {
    Component: HomeCTA,
    columnSpan: 1,
    rowSpan: 1
  },
  wscBlazeModule: {
    Component: WSCBlaze,
    columnSpan: 4,
    rowSpan: 1
  },
  storytellerModule: {
    Component: StoryTeller,
    columnSpan: 4,
    rowSpan: 1
  },
  featuredTournamentModule: {
    Component: Events,
    columnSpan: 1,
    rowSpan: 1
  },
  adBannerModule: {
    Component: AdBanner,
    columnSpan: 4,
    rowSpan: 1
  }
};
